import { Appearance } from 'react-native';
import { lightTheme, lightStyleTheme } from './lightTheme';
import { darkTheme, darkStyleTheme } from './darkTheme';

export type ThemeMode = 'light' | 'dark';

let activeMode: ThemeMode =
    Appearance.getColorScheme() === 'dark' ? 'dark' : 'light';

export function setActiveTheme(mode: ThemeMode) {
    activeMode = mode;
}

export function getActiveTheme(): ThemeMode {
    return activeMode;
}

const proxy = <T extends object>(light: T, dark: T): T =>
    new Proxy({} as T, {
        get(_, prop) {
            const target: any = activeMode === 'dark' ? dark : light;
            return target[prop];
        },
        ownKeys() {
            const target: any = activeMode === 'dark' ? dark : light;
            return Reflect.ownKeys(target);
        },
        getOwnPropertyDescriptor(_, prop) {
            const target: any = activeMode === 'dark' ? dark : light;
            return Object.getOwnPropertyDescriptor(target, prop);
        },
        has(_, prop) {
            const target: any = activeMode === 'dark' ? dark : light;
            return prop in target;
        },
    });

const styles: any = proxy(lightTheme as any, darkTheme as any);
const styleTheme: any = proxy(lightStyleTheme as any, darkStyleTheme as any);

export { styles, styleTheme };
